// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BaseEntity } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/BaseEntity';
/**
 * 部署记录 实体类
 * 部署记录
 */
export class DeployRecord extends BaseEntity {
  /** 工作区间名称 : 工作区间名称 */
  private _workSpaceName: string;

  /** 设置：工作区间名称 */
  public get workSpaceName() {
    return this._workSpaceName;
  }

  /** 获取：工作区间名称 */
  public set workSpaceName(value: string) {
    this._workSpaceName = value;
  }

  /** 产品名称 : 产品名称 */
  private _productName: string;

  /** 设置：产品名称 */
  public get productName() {
    return this._productName;
  }

  /** 获取：产品名称 */
  public set productName(value: string) {
    this._productName = value;
  }

  /** 应用名称 : 应用名称 */
  private _appName: string;

  /** 设置：应用名称 */
  public get appName() {
    return this._appName;
  }

  /** 获取：应用名称 */
  public set appName(value: string) {
    this._appName = value;
  }

  /** 应用唯一标识 : 应用唯一标识 */
  private _appKey: string;

  /** 设置：应用唯一标识 */
  public get appKey() {
    return this._appKey;
  }

  /** 获取：应用唯一标识 */
  public set appKey(value: string) {
    this._appKey = value;
  }

  /** stack内容 : stack内容(替换后的compose) */
  private _fileContent: string;

  /** 设置：stack内容 */
  public get fileContent() {
    return this._fileContent;
  }

  /** 获取：stack内容 */
  public set fileContent(value: string) {
    this._fileContent = value;
  }

  /** 部署栈id : 部署栈id */
  private _stackId: number;

  /** 设置：部署栈id */
  public get stackId() {
    return this._stackId;
  }

  /** 获取：部署栈id */
  public set stackId(value: number) {
    this._stackId = value;
  }

  /** 总任务Id : 总任务Id */
  private _taskId: string;

  /** 设置：总任务Id */
  public get taskId() {
    return this._taskId;
  }

  /** 获取：总任务Id */
  public set taskId(value: string) {
    this._taskId = value;
  }

  /** 部署状态 : 部署状态 */
  private _deployStatus: boolean;

  /** 设置：部署状态 */
  public get deployStatus() {
    return this._deployStatus;
  }

  /** 获取：部署状态 */
  public set deployStatus(value: boolean) {
    this._deployStatus = value;
  }

  constructor() {
    super();
    this._workSpaceName = '';
    this._productName = '';
    this._appName = '';
    this._appKey = '';
    this._fileContent = '';
    this._stackId = 0;
    this._taskId = '';
    this._deployStatus = false;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: DeployRecord, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.workSpaceName = element.workSpaceName;
      this.productName = element.productName;
      this.appName = element.appName;
      this.appKey = element.appKey;
      this.fileContent = element.fileContent;
      this.stackId = element.stackId;
      this.taskId = element.taskId;
      this.deployStatus = element.deployStatus;
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.workSpaceName = json.WorkSpaceName;
    this.productName = json.ProductName;
    this.appName = json.AppName;
    this.appKey = json.AppKey;
    this.fileContent = json.FileContent;
    this.stackId = json.StackId;
    this.taskId = json.TaskId;
    this.deployStatus = json.DeployStatus;
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.WorkSpaceName = this.workSpaceName;
    json.ProductName = this.productName;
    json.AppName = this.appName;
    json.AppKey = this.appKey;
    json.FileContent = this.fileContent;
    json.StackId = this.stackId;
    json.TaskId = this.taskId;
    json.DeployStatus = this.deployStatus;
  }

  static Create(json: any): DeployRecord {
    const deployRecord = new DeployRecord();
    deployRecord.Deserialize(json);
    deployRecord.json = json;
    return deployRecord;
  }
}
